module.exports = __webpack_public_path__ + "static/media/DM-Negative-Clip-4.f68cfbe3.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/success/DM-Negative-Clip-4.mp3
// module id = 134
// module chunks = 0